module.exports = __webpack_public_path__ + "static/paiement-72145d670e28dcf7e8eaa38c3e36a7c2.png";